import React, { memo, forwardRef, useContext, useMemo } from 'react';
import cn from 'classnames';
import { Box } from '../../box';
import { SlotContext } from '../../slots';
import { ModalContext } from '../contexts';
import styles from './styles.module.css';
import baseStyles from '../styles.module.css';
const defaultControlsSize = {
    'm': 'l',
    's': 'm',
};
const ModalFooter = memo(forwardRef(function Footer(props, ref) {
    const { className, children, ...rest } = props;
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('Modal component has to be placed inside Modal.Overlay');
    }
    const { modalProps: { size }, } = context;
    const slotContextValue = useMemo(() => ({ size: defaultControlsSize[size] }), [size]);
    return (React.createElement(Box, { ref: ref, p: size, className: cn(baseStyles.footer, styles.footer, className), flexDirection: "column", ...rest }, children && (React.createElement(SlotContext.Provider, { value: slotContextValue }, children))));
}));
export const Controls = ({ layout = 'even', children, ...rest }) => {
    return (React.createElement(Box, { className: cn(styles.controls, { even: styles.even, custom: undefined }[layout]), gap: "s", alignItems: "center", ...rest }, children));
};
export const Footer = Object.assign(ModalFooter, {
    Controls,
});
